import Vue from 'vue/dist/vue.esm.js';
import { formattedPriceUtils } from '../utils/currencyUtils';

Vue.component('cart-widget', {
    template: `#cart-widget`,
    delimiters: ['[[', ']]'],
    props: {
        initialCart: {
            required: true,
            type: Object,
        },
        locale: {
            required: true,
            type: String,
        },
        currency: {
            required: true,
            type: String,
        },
        removeCartRowUrl: {
            required: true,
            type: String,
        },
        convertMode: {
            required: true,
            type: String,
        },
        exchangeRateMode: {
            required: true,
            type: String,
        },
        exchangeRate: {
            required: true,
            type: String,
        },
    },

    mounted() {
        EventManager.listen('item-added', this.cartUpdated);
        EventManager.listen('item-removed', this.cartUpdated);
    },

    data() {
        return {
            cart: this.initialCart,
        }
    },

    methods: {
        cartUpdated(data) {
            this.cart = JSON.parse(data);
        },

        removeRow(rowId, removeItemUrl) {
            this.buildAjax(rowId, removeItemUrl);
        },

        formattedPrice(price) {
            return formattedPriceUtils(price, this.exchangeRate, this.exchangeRateMode, this.convertMode, true);
        },

        formattedPriceToEUR(price) {
            return formattedPriceUtils(price, this.exchangeRate, this.exchangeRateMode, this.convertMode, true);
        },

        buildAjax(rowId, url) {
            let _self = this
            $.ajax({
                data: {id: rowId},
                url: url,
                method: 'POST',
                success: function (result) {
                    _self.successAjax(result)
                },
            });
        },

        successAjax(result) {
            if (result.success === false) {
                return;
            }

            EventManager.fire('item-removed', result.cart);

            let event = {
                event: 'eec.remove',
                eventData: result.variant,
                action: 'CartWidget',
            }
            EventManager.fire('gtm-event',event);
        },
        concatenateAttributeValues(attributes) {
            let str = '';
            for (let [index,attribute] of attributes.entries()) {
                if(index !== 0){
                    str += ', '
                }
                if(attribute.showUnit){
                    str += attribute.unit + ' x '
                }
                str +=  ' ' + attribute.value;

            }
            return str;
        }
    },

    computed: {
        total() {
            return this.formattedPrice(this.cart.total)
        }
    }
});